import {Box, Paper, Typography} from "@mui/material";

export default function MyDealsNoPropertiesButHasRFPs() {
  return (
    <>
      <Box
        sx={{
          height: "60px",
          display: "flex",
          alignItems: "center",
        }}
      ></Box>
      <Box
        sx={{
          height: "calc(100% - 60px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper
          sx={{
            height: "600px",
            width: "650px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={"/images/thinking man.png"}
            alt="IMG"
            style={{
              height: "300px",
              width: "350px",
              marginBottom: "25px",
            }}
          />
          <Typography sx={{fontWeight: 800, fontSize: "23px"}}>
            You don't have any property deals.
          </Typography>
          <Typography sx={{fontWeight: 400, fontSize: "16px"}}>
            Filter the Category to Services (RFPs) to see the Service Card(s)
          </Typography>
        </Paper>
      </Box>
    </>
  );
}
